<template>
	<button
		class="bg-body hidden h-8 w-8 min-w-8 cursor-pointer items-center justify-center rounded-full lg:flex"
		alt="fullscreen-switch"
		aria-label="fullscreen-switch"
		@click="toggle()"
	>
		<Icon v-if="isFullscreen" :size="17" name="carbon:minimize" />
		<Icon v-else :size="17" name="carbon:maximize" />
	</button>
</template>

<script lang="ts" setup>
import Icon from "@/components/common/Icon.vue"
import { useFullscreenSwitch } from "@/composables/common/useFullscreenSwitch"

const { isFullscreen, toggle } = useFullscreenSwitch()
</script>
